import { useEffect } from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { LOCALES, LocaleContext, detectLocale } from "../i18n";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { SiteMeta } from "../components/SiteMeta";

const useScrollTopOnPageChange = () => {
  const { pathname } = useLocation();
  const page = pathname.replace(/^\/(en|ja)/, "");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);
};

export default function LocaleLayout() {
  const { lang } = useParams();
  const { pathname, search } = useLocation();
  useScrollTopOnPageChange();

  useEffect(() => {
    if (LOCALES.includes(lang)) document.documentElement.lang = lang;
  }, [lang]);

  if (!LOCALES.includes(lang)) return <Navigate to={`/${detectLocale()}${pathname}${search}`} replace />;

  return (
    <LocaleContext.Provider value={lang}>
      <SiteMeta />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </LocaleContext.Provider>
  );
}
